import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import { useNavigate } from "react-router-dom";
import { getAllSuppliers } from "../../reduxSaga/actions";

import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import { Button, Snackbar, TextField } from "@material-ui/core";
import PurchaseService from "../../services/PurchaseOrder";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import { Alert } from "@material-ui/lab";

import UploadPOFile from "../../ui/UploadPOFile";
const PurchaseOrders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const suppliers = useSelector((state) => state.staff.suppliers.Societe);

  const [oldWarehouseData, setOldWarehouseData] = useState();
  // const [onAddSubFamily, setOnAddSubFamily] = useState(false);
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const [supplierSelectPlaceHolder, setSupplierSelectPlaceHolder] =
    useState("Tous");
  const [allSuppliers, setAllSuppliers] = useState([
    { value: 0, label: "Tous" },
  ]);
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [supplierSelectedOption, setSupplierSelectedOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inConfirmedPO, setInConfirmedPO] = useState([]);
  const [purchaseOrderRelatedToFacture, setPurchaseOrderRelatedToFacture] =
    useState([]);
  const [inFineshedPo, setInFineshedPo] = useState([]);
  const [archivedPO, setArchivedPO] = useState([]);
  const [finishedPO, setFinishedPO] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [purchaseOrderUploadInformation, setPurchaseOrderUploadInformation] =
    useState({
      reference: "any",
      state: 0,
      inConfirmedPO: inConfirmedPO,
    });

  useEffect(() => {
    if (onUploadFile === "false") {
      console.log("inConfirmedPO", inConfirmedPO);
    }
  }, [onUploadFile]);
  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }

    dispatch(getAllSuppliers());

    PurchaseService.getPOOfLastMonth(0)
      .then((response) => {
        console.log(response);
        if (Object.keys(response.data)[0] === "success") {
          response.data.success.forEach((element) => {
            // if (element.state === 0) {

            setInConfirmedPO((previoustate) => [...previoustate, element]);
            // }
            //  else if (element.state === 1) {
            //   setInFineshedPo((previoustate) => [...previoustate, element]);
            // } else if (element.state === 2) {
            //   setFinishedPO((previoustate) => [...previoustate, element]);
            // } else if (element.state === 3) {
            //   setPurchaseOrderRelatedToFacture((previoustate) => [
            //     ...previoustate,
            //     element,
            //   ]);
            // }
          });
        } else if (Object.keys(response.data)[0] === "empty") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    PurchaseService.getPOOfLastMonth(1)
      .then((response) => {
        console.log(response);

        if (Object.keys(response.data)[0] === "success") {
          setArchivedPO(response.data.success);
        } else if (Object.keys(response.data)[0] === "empty") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  }, []);

  useEffect(() => {
    suppliers &&
      suppliers.map((element, i) => {
        let exist = false;
        if (allSuppliers.length !== 0) {
          for (let index = 0; index < allSuppliers.length; index++) {
            if (allSuppliers[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllSuppliers((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title },
          ]);
        }
      });
  }, [suppliers]);

  useEffect(() => {
    if (dateBegin === ":59") {
      setDateBegin("any");
    }
    if (dateEnd === ":59") {
      setDateEnd("any");
    }
  }, [dateBegin, dateEnd]);

  const onAddPOHandler = () => {
    navigate(`/addPurchaseOrder`);
  };

  const onArchiveHandler = (refDocument, isDeleted) => {
    PurchaseService.deleteAndRestorePO(refDocument, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          if (isDeleted === 1) {
            let newState = finishedPO.filter(
              (item) => item.reference !== refDocument
            );
            setFinishedPO(newState);

            let new_array = add_items_to_array_at_position(archivedPO, 0, [
              response.data.success,
            ]);

            setArchivedPO(new_array);
          } else if (isDeleted === 0) {
            let newState = archivedPO.filter(
              (item) => item.reference !== refDocument
            );
            console.log("hzhzhhehehe", newState);
            setArchivedPO(newState);

            let new_array = add_items_to_array_at_position(finishedPO, 0, [
              response.data.success,
            ]);
            console.log("hzhzh22hehehe", new_array);
            setFinishedPO(new_array);
          }
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  const onViewProductsHandler = (refDocument, NoteDocument) => {
    navigate(`/document/products/${refDocument}/${"bdc"}/${NoteDocument}`);
  };

  const onViewDevisProductsHandler = (refDocument, NoteDocument) => {
    navigate(`/document/products/${refDocument}/${"devis"}/${NoteDocument}`);
  };

  const onViewFactureProductsHandler = (refDocument, NoteDocument) => {
    navigate(`/document/products/${refDocument}/${"facture"}/${NoteDocument}`);
  };

  const onViewPOProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "po");

    navigate("/getDocumentByRef");
    // navigate(`/document/products/${refDocument}/${"po"}/${NoteDocument}`);
  };

  const onViewPOHistoryInThatWarehouse = (idDocument) => {
    sessionStorage.setItem("DocumentId", idDocument);
    sessionStorage.setItem("typeDocument", "po");

    navigate("/historiqueLivraison");
    // navigate(
    //   `/document/products/${documentReference}/${idWarehouse}/${"documentHistory"}/${NoteDocument}/${warehouseName}`
    // );
  };

  const onChangeSelectedSupplier = (selectedOptionn) => {
    setSelectedOption();
    setSupplierId(selectedOptionn.value);
    setSupplierSelectPlaceHolder(selectedOptionn.label);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  function add_items_to_array_at_position(array, index, new_items) {
    return [...array.slice(0, index), ...new_items, ...array.slice(index)];
  }

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value.concat(":59"));
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value.concat(":59"));
  };
  const onGetPOByFiltersHandler = () => {
    console.log(dateBegin);
    console.log(dateEnd);
    console.log(supplierId);
    for (let state = -1; state < 4; state++) {
      PurchaseService.getPOByFilters(supplierId, state, dateBegin, dateEnd)
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            if (state === -1) {
              setArchivedPO(response.data.success);
            } else if (state === 0) {
              setInConfirmedPO(response.data.success);
            } else if (state === 1) {
              setFinishedPO(response.data.success);
            } else if (state === 2) {
              setInFineshedPo(response.data.success);
            } else if (state === 3) {
              setPurchaseOrderRelatedToFacture(response.data.success);
            }
          } else if (Object.keys(response.data)[0] === "empty") {
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file

        const file = new Blob([response.data], { type: "application/pdf" });
        //  const file = new Blob([fileDisplay], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.location.href = fileURL;
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  const onUploadFileHandler = (state, reference, index, isDeleted) => {
    if (isDeleted === 0) {
      if (state === 0) {
        setPurchaseOrderUploadInformation({
          reference: reference,
          state: state,
          index: index,
          poData: inConfirmedPO,
          isDeleted: 0,
        });
        console.log(state);
        console.log(reference);
        console.log(index);
        console.log(isDeleted);
      } else if (state === 1) {
        setPurchaseOrderUploadInformation({
          reference: reference,
          state: state,
          index: index,
          poData: inFineshedPo,
        });
      } else if (state === 2) {
        setPurchaseOrderUploadInformation({
          reference: reference,
          state: state,
          index: index,
          poData: finishedPO,
          isDeleted: 0,
        });
      }
    } else if (state === 3) {
      setPurchaseOrderUploadInformation({
        reference: reference,
        state: state,
        index: index,
        poData: purchaseOrderRelatedToFacture,
        isDeleted: 0,
      });
    } else {
      setPurchaseOrderUploadInformation({
        reference: reference,
        state: state,
        index: index,
        poData: archivedPO,
        isDeleted: 1,
      });
    }

    setOnUploadFile(true);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">Ajouter les achats</h5>

              {(userRole.includes("ADMIN") ||
                userRole.includes("PURCHASING_MANAGER")) && (
                <button
                  class="btn btn-dark  float-right"
                  onClick={onAddPOHandler}
                >
                  {" "}
                  <i class="fas fa-plus"></i>
                </button>
              )}
              <br />
              <div className="row">
                <p>
                  <small>
                    Initialement il y a les achats ajoutées durant ce dernier
                    mois
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Choisir le Fournisseur
                        </label>
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          defaultValue={supplierSelectedOption}
                          onChange={onChangeSelectedSupplier}
                          options={allSuppliers}
                          placeholder={supplierSelectPlaceHolder}
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          // label="Date Début"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          // label="Date fin"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetPOByFiltersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card">
                <div class="card-header  ">
                  <h6 class="card-title">Les achats </h6>
                  <div class="card-tools">
                    <button
                      type="button"
                      class="btn btn-tool"
                      data-card-widget="collapse"
                      title="Collapse"
                    >
                      <i class="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body p-0">
                  <table
                    class="table table-striped table-bordered table-sm"
                    cellspacing="0"
                    width="100%"
                  >
                    <thead>
                      <tr className="text-center">
                        <th style={{ width: "20%" }}>Réference</th>
                        <th>Fournisseur</th>
                        <th style={{ width: "12%" }}>DC</th>
                        <th style={{ width: "12%" }}>Prix.A.HT</th>
                        <th style={{ width: "12%" }}>Prix.A.TT</th>
                        <th style={{ width: "11%" }}>Facture</th>
                        <th style={{ width: "8%" }}>Livraison</th>
                        <th style={{ width: "11%" }}>Info</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inConfirmedPO &&
                        inConfirmedPO.map((element, i) => (
                          <tr key={i}>
                            <td>{element.reference}</td>
                            <td>{element.supplierTitle} </td>
                            <td>{element.creationDate}</td>
                            <td>{element.buyingPrice}</td>
                            <td>{element.ttPrice}</td>

                            {element.factureReference !== "any" ? (
                              <td className="text-center">
                                {element.factureReference}
                              </td>
                            ) : (
                              <td className="text-center">
                                <i class="fas fa-solid fa-ban"></i>
                              </td>
                            )}
                            {element.state === 0 && (
                              <td className="text-center">
                                <span className="badge bg-warning">
                                  En attente
                                </span>{" "}
                              </td>
                            )}
                            {element.state === 1 && (
                              <td className="text-center">
                                {console.log("element", element)}
                                <a
                                  onClick={() => {
                                    onViewPOHistoryInThatWarehouse(
                                      element.idPO
                                    );
                                  }}
                                >
                                  <span className="badge bg-primary">
                                    En cours
                                  </span>{" "}
                                </a>
                              </td>
                            )}
                            {element.state === 2 && (
                              <td className="text-center">
                                <a
                                  onClick={() => {
                                    onViewPOHistoryInThatWarehouse(
                                      element.idPO
                                    );
                                  }}
                                >
                                  <span className="badge bg-success">
                                    Terminé
                                  </span>
                                </a>
                              </td>
                            )}
                            <td className="text-center">
                              <button
                                style={{ width: 40 }}
                                class="btn bg-black btn-sm "
                                onClick={() =>
                                  onViewPOProductsHandler(
                                    element.reference,
                                    element.note
                                  )
                                }
                              >
                                <i class="fas fa-shopping-cart"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card">
                <div class="card-header  ">
                  <h6 class="card-title">Les achats archivés </h6>
                  <div class="card-tools">
                    <button
                      type="button"
                      class="btn btn-tool"
                      data-card-widget="collapse"
                      title="Collapse"
                    >
                      <i class="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body p-0">
                  <table
                    class="table table-striped table-bordered table-sm"
                    cellspacing="0"
                    width="100%"
                  >
                    <thead>
                      <tr className="text-center">
                        <th style={{ width: "20%" }}>Réference</th>
                        <th>Fournisseur</th>
                        <th style={{ width: "12%" }}>DC</th>
                        <th style={{ width: "10%" }}>Prix.A.HT</th>
                        <th style={{ width: "10%" }}>Prix.A.TT</th>
                        <th style={{ width: "11%" }}>Facture</th>
                        <th style={{ width: "11%" }}>Restaurer</th>
                        <th style={{ width: "11%" }}>Info</th>
                      </tr>
                    </thead>

                    <tbody>
                      {archivedPO &&
                        archivedPO.map((element, i) => (
                          <tr key={i}>
                            <td>{element.reference}</td>
                            <td>{element.supplierTitle} </td>

                            <td>{element.creationDate}</td>
                            <td>{element.buyingPrice}</td>
                            <td>{element.ttPrice}</td>
                            {element.factureReference !== "any" ? (
                              <td className="text-center">
                                {element.factureReference}
                              </td>
                            ) : (
                              <td className="text-center">
                                <i class="fas fa-solid fa-ban"></i>
                              </td>
                            )}

                            <td className="text-center">
                              <button
                                style={{ width: 40 }}
                                class="btn btn-secondary btn-sm"
                                onClick={() =>
                                  onArchiveHandler(element.reference, 0)
                                }
                              >
                                <RestoreFromTrashRoundedIcon />
                              </button>
                            </td>

                            {/* {element.bonDeLivraison.length > 1 ? (
                              <td>
                                <div class="dropdown">
                                  <button
                                    class="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    BDL
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    {" "}
                                    {element.bonDeLivraison.map(
                                      (pathBonLivraison, i) => (
                                        <p
                                          class="dropdown-item"
                                          onClick={() =>
                                            onShowFileInOtherWizndowHandler(
                                              pathBonLivraison
                                            )
                                          }
                                        >
                                          bon de livraison <span> {i} </span>
                                        </p>
                                      )
                                    )}
                                  </div>
                                </div>
                              </td>
                            ) : element.bonDeLivraison.length === 1 ? (
                              <td>
                                <button
                                  style={{ fontSize: 10, height: 36 }}
                                  class="btn btn-secondary btn-sm"
                                  onClick={() =>
                                    onShowFileInOtherWizndowHandler(
                                      element.bonDeLivraison[0]
                                    )
                                  }
                                >
                                  Bon de livraison
                                </button>
                              </td>
                            ) : (
                              <td>
                                <button class="btn btn-primary btn-sm" disabled>
                                  <i
                                    class="fas fa-folder"
                                    style={{ marginRight: 3 }}
                                  ></i>
                                  Vide
                                </button>
                              </td>
                            )} */}

                            <td className="text-center">
                              <button
                                style={{ width: 40 }}
                                class="btn bg-black btn-sm"
                                onClick={() =>
                                  onViewPOProductsHandler(
                                    element.reference,
                                    element.note
                                  )
                                }
                              >
                                <i class="fas fa-shopping-cart"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {onUploadFile && (
        <UploadPOFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedPO={setInConfirmedPO}
          setPurchaseOrderRelatedToFacture={setPurchaseOrderRelatedToFacture}
          setInFineshedPo={setInFineshedPo}
          setFinishedPO={setFinishedPO}
          purchaseOrderUploadInformation={purchaseOrderUploadInformation}
          setArchivedPO={setArchivedPO}
        />
      )}
    </div>
  );
};
export default PurchaseOrders;
